import React from "react";
import moment from "moment";
import { Table } from "reactstrap";
import {
  applyClassToCharacters,
  LoadingSpinner,
} from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { GetSelectedLanguage } from "../../helper/Method";
import UploadStatus from "../UploadStatus";
import "./DocumentTables.css";

const DocumentUnitFoldersTable = ({
  state,
  t,
  handlers,
  openFolder,
  formatSize,
  getFileIcon,
  getUnitName,
}) => (
  <div className="panel-body">
    {state.loading ? (
      LoadingSpinner()
    ) : state.unitFolders.length === 0 ? (
      <div style={{ padding: "20px" }}>{t("common_no_record_found")}</div>
    ) : (
      <Table responsive hover bordered>
        <thead style={{ cursor: "default", userSelect: "none" }}>
          <tr>
            <th>#</th>
            <th>
              <GetLanguageString props={"common_name"} />
            </th>
            <th>
              <GetLanguageString props={"member_member_detail_document_upload_date"} />
            </th>
            {state.resultFromSearch && (
              <th>
                <GetLanguageString props={"folder_path"} />
              </th>
            )}
            <th>
              <GetLanguageString props={"member_member_detail_document_size"} />
            </th>
            <th>
              <GetLanguageString props={"dashboard_event_page_status"} />
            </th>
          </tr>
        </thead>
        <tbody>
          {state.unitFolders.map((file, index) => (
            <tr
              key={file.id || index}
              className={
                state.unitSelectedRowIndex === index
                  ? "documents-table-row is-selected"
                  : "documents-table-row"
              }
              onClick={(e) => {
                if (!e.target.closest(".unclickable-column")) {
                  state.setUnitSelectedRowIndex(
                    index === state.unitSelectedRowIndex ? null : index
                  );
                }
              }}
              onDoubleClick={(e) => {
                if (
                  !e.target.closest(".unclickable-column") &&
                  file.fileType?.includes("folder") &&
                  !state.deletionInProgress
                ) {
                  openFolder(file);
                }
              }}
              style={{ cursor: "default" }}
            >
              <td>{index + 1}</td>
              <td style={{ userSelect: "none" }}>
                {getFileIcon(file.fileType || "")}
                &nbsp;
                {applyClassToCharacters(file.name, "ur")}
                &nbsp;
                {file.isUnitDeleted && (
                  <GetLanguageString props={"folder_unit_deleted"} />
                )}
              </td>
              <td>
                {file.createdDate ? (
                  <>
                    {moment(file.createdDate)
                      .locale(GetSelectedLanguage())
                      .format("DD/MM/YYYY")}
                    &nbsp;
                    {GetSelectedLanguage() === "ur"
                      ? moment(file.createdDate)
                          .locale(GetSelectedLanguage())
                          .format("a h:mm")
                      : moment(file.createdDate)
                          .locale(GetSelectedLanguage())
                          .format("h:mm a")}
                  </>
                ) : (
                  "-"
                )}
              </td>
              {state.resultFromSearch && <td>{getUnitName(file.folderPath)}</td>}
              <td>{file.size ? formatSize(file.size) : "-"}</td>
              <td>
                <UploadStatus
                  fileStatus={file.fileStatus}
                  jobId={file.fileUploadBackgroundJobId}
                  uploadRefreshDocuments={handlers.uploadRefreshDocuments}
                  fileId={file.id}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )}
  </div>
);

export default DocumentUnitFoldersTable;
